import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Box, Typography,IconButton } from '@mui/material';

import { Nextstep } from './features/counterSlice';

function ReadActivity({pages,nextpage}) {
    const pagestep = useSelector((state) => state.counter.value);
    const dispatch = useDispatch();
    const [showActivity, setShowActivity] = useState(false);
    const handleClick = () => {
        // Call the passed function to change the parent's state
        dispatch(Nextstep());
    };
    return (
        <Box sx={{ maxWidth: 800, margin: 'auto', p: 2, textAlign: 'center' }}>
            {/* Fixed Header Section */}
             
            <Box display="flex" justifyContent="center" alignItems="center" minHeight="50vh">
                    <Box
                        sx={{
                            padding: 4,
                            borderRadius: 10,
                            boxShadow: 3,
                            textAlign: 'center',
                            maxWidth: 600,
                            backgroundColor: '#fff',
                            borderWidth: 2,
                            borderColor: '#e520b2',
                            borderStyle: 'solid'
                        }}
                    >
                        <Typography variant="body1" sx={{ mb: 2 }}>
                            This is a <span style={{ color: '#ff02bd' }}> READING ACTIVITY.</span> . In this activity, the students will   <b>read the instructions carefully and answer the questions</b>  based on them.
Time Duration: 05 Minutes
                    </Typography>
                    </Box>
                </Box>
            
                <Box mt={3} textAlign={'center'}>
                <IconButton variant="contained" color="secondary" onClick={handleClick}  sx={{ padding: '10px 40px' }}>
                <img src="/images/Picture6.png" alt="Play audio" style={{ width: '150px',height:'auto' }} />
                </IconButton>
            </Box>
            
        </Box>
    );
}

export default ReadActivity;
